import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";

export function usePermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  const canAddProvider = permissions.includes("provider.add_provider");

  return {
    canAddProvider,
  };
}
